import { render } from "./TheButton.vue?vue&type=template&id=79c6b63b&scoped=true&ts=true"
import script from "./TheButton.vue?vue&type=script&lang=ts"
export * from "./TheButton.vue?vue&type=script&lang=ts"

import "./TheButton.vue?vue&type=style&index=0&id=79c6b63b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6b63b"]])

export default __exports__